import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReportsService } from 'src/app/_services/reports.service';

@Component({
  selector: 'app-worker-report',
  templateUrl: './worker-report.component.html',
  styleUrls: ['./worker-report.component.scss'],

  providers: [DatePipe],
})
export class WorkerReportComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  userData;
  subscriptions: Subscription[] = [];
  form: FormGroup;
  allUsers: any;

  dataInfo = [];
  productionInfo: any;

  constructor(
    private reportsService: ReportsService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      date_from: ['', Validators.required],
      date_to: ['', Validators.required],
      userId: ['', Validators.required],
    });

    this.getAllUsers();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(userId, dateFrom, dateTo) {
    this.loading = true;
    this.userData = [];
    this.subscriptions.push(
      this.reportsService
        .getWorkersReport(userId, dateFrom, dateTo)
        .subscribe((responseData: any) => {
          this.dataInfo = [];
          this.userData = responseData;

          this.dataInfo.push({
            total_break_time: responseData.total_break_time,
          });
          this.dataInfo.push({
            total_logout_time: responseData.total_logout_time,
          });
          this.dataInfo.push({ total_work_time: responseData.total_work_time });
        })
    );
  }

  onSearch() {
    const form = this.form.getRawValue();

    if (this.form.valid) {
      form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
      form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

      this.getData(form.userId, form.date_from, form.date_to);
    }
  }

  onExportPdf() {
    const form = this.form.getRawValue();

    form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
    form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

    this.subscriptions.push(
      this.reportsService
        .exportWorkersToPDF(form.userId, form.date_from, form.date_to)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
        })
    );
  }

  /* ====================================
   *             HELPERS
   ======================================= */
  clearFilters(controlName) {
    this.form.get(controlName).setValue('');
  }

  getAllUsers() {
    this.loading = true;
    this.subscriptions.push(
      this.reportsService.getAllUsers().subscribe((users: any) => {
        this.allUsers = users.map((user) => {
          return {
            ...user,
            name: `${user?.fname} ${user?.lname}`,
          };
        });
      })
    );
  }
}
